import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { ErrorDetailsState } from '@store';

@Component({
  selector: 'app-error-search-results',
  templateUrl: './error-search-results.component.html',
  styleUrls: ['./error-search-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorSearchResultsComponent {
  @Input() dataState$: Observable<ErrorDetailsState>;

  constructor() {}
}
